<div #overlayDiv *ngIf="displayOverlay" class="mat-elevation-z4 overlay-layout">

    <tree-property-options-overlay-content [inputData]="overlayContent" (result)="handleResultEvent($event)">
    </tree-property-options-overlay-content>
</div>